import React, { useEffect} from "react";
import { useTranslation } from "react-i18next";
import OfficesSelect from "../../form/OfficesSelect";
import FormSection from "../../form/Section";
import FormRepeater from "../../form/FormRepeater";
import CardRow from "./CardRow";
import InfoChip from "../../InfoChip";
import Amount from "../../Amount";
import CorporateCustomersSelect from "../../form/CorporateCustomersSelect";

const AddCard = ({ formData, setFormData }) => {
    const { t } = useTranslation();
  
    return (
        <div className="step">
            <div className="container">
                <div className="row mb-2">
                    <div className="col-xs-12 col-md-6">
                        <FormSection title={t("Select an Office")} required>
                            <OfficesSelect
                                onChange={officeId => setFormData(prevData => ({
                                    ...prevData,
                                    office_id: officeId
                                }))}
                                setProvinceCode={provinceCode => setFormData(prevData => ({
                                    ...prevData,
                                    province_code: provinceCode
                                }))}
                                defaultOfficeIds={[formData.office_id]}
                            />
                        </FormSection>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <FormSection title={t("Client Company Name")}>
                            <CorporateCustomersSelect
                                onChange={customer => setFormData(prevData => ({
                                    ...prevData,
                                    corporate_customer_id: customer.value,
                                    client_company_name: customer.label
                                }))}
                                defaultCustomerIds={[formData.corporate_customer_id]}
                            />
                        </FormSection>
                    </div>
                </div>

                <div className="mb-3">
                    <h5 className="mb-0">{t("Card")}</h5>
                    <hr className="size-3"/>
                    <FormRepeater
                        columns={[
                            t("Start Proxy Number"),
                            t("End Proxy Number"),
                            "",
                            t("Card Type"),
                            t("Load Amount"),
                            t("Action"),
                        ]}
                        maxRows={1}
                        addRowText={t("Add Card")}
                        RenderComponent={CardRow}
                        onRowChange={card => setFormData(prevData => ({
                            ...prevData,
                            card
                        }))}
                        rowData={formData.card}
                        formData={formData}
                        setFormData={setFormData}
                    />
                </div>
                <div className="text-right">
                    <InfoChip value={Number(formData.quantity)} description={t('Cards')} className="mr-3"/>
                    <InfoChip value={<Amount amount={formData.subtotal_cost} />} description={t('Total Amount')}/>
                </div>
            </div>
        </div>
    );
};

export default AddCard;